var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.82149 11L7.32149 8.5M11.4968 2.25V1M14.7796 3.55055L15.6634 2.66667M14.7796 10.1667L15.6634 11.0506M8.16345 3.55055L7.27957 2.66667M16.0801 6.83333H17.3301M4.09763 16.7239L11.7953 9.02614C12.1254 8.69613 12.2904 8.53112 12.3522 8.34085C12.4066 8.17348 12.4066 7.99319 12.3522 7.82582C12.2904 7.63555 12.1254 7.47054 11.7953 7.14052L11.181 6.52614C10.851 6.19613 10.6859 6.03112 10.4957 5.9693C10.3283 5.91492 10.148 5.91492 9.98064 5.9693C9.79037 6.03112 9.62536 6.19613 9.29535 6.52614L1.59763 14.2239C1.26762 14.5539 1.10261 14.7189 1.04079 14.9092C0.986405 15.0765 0.986405 15.2568 1.04079 15.4242C1.10261 15.6145 1.26762 15.7795 1.59763 16.1095L2.21201 16.7239C2.54203 17.0539 2.70703 17.2189 2.89731 17.2807C3.06468 17.3351 3.24497 17.3351 3.41234 17.2807C3.60261 17.2189 3.76762 17.0539 4.09763 16.7239Z",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.b8d1da3a2a10b74f11854943efc86117.svg";
export { ForwardRef as ReactComponent };